// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBsscN7Xe1TQIc4Edx3BaDX0RA-jSHw00w	',
    authDomain: 'chispa-rural.firebaseapp.com',
    databaseURL: 'https://chispa-rural.firebaseio.com/',
    projectId: 'chispa-rural',
    storageBucket: 'gs://chispa-rural.appspot.com',
    messagingSenderId: '255921926407'
  }
};



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/environments/environment.ts